import React from 'react'
import Login from '../components/Section/Login'

function login() {
  return (
    <div className='bg-[#0C2341] container min-h-screen'>
      <Login/>
    </div>
  )
}

export default login

